import React, { useState, useEffect } from "react";
import { Form, Tabs, Tab, Row, Col } from "react-bootstrap";
import Select from "react-select";
//components
import Navbar from "../../Components/Navbar/Navbar";
import Table from "../../Components/TableTemplate/Table";

//css
import "./Inventory.css";
import "../../Components/Navbar/Navbar.css";
import {
  searchAllItemList,
} from "../../Helpers/apiCalls/Inventory/ItemListApi";
// import { getAllBranches } from "../../Helpers/apiCalls/Purchases/purchaseOrderApi";
import { useNavigate } from "react-router-dom";
import {
  getBranchId,
  getType,
  isAdmin,
  numberFormat,
  selectDropdownStyle,
} from "../../Helpers/Utils/Common";
import { getCategory } from "../../Helpers/apiCalls/categoryApi";
import { getBrand } from "../../Helpers/apiCalls/brandsApi";
import { searchBranch } from "../../Helpers/apiCalls/Manage/Branches";
import Footer from "../../Components/Footer/Footer";
import TableWithDynamicPagination from "../../Components/TableTemplate/TableWithDynamicPagination";

export default function BranchInventory() {
  const navigate = useNavigate();
  const accountType = getType()
  const [inactive, setInactive] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [inventoryList, setInventoryList] = useState([]);
  const [filterConfig, setFilterConfig] = useState({
    tab: "all", 
    branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
    page: 1
  });
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [brand, setBrand] = useState([]);
  const [branches, setBranches] = useState([])
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Change this based on your requirement

  const handlePageChange = page => {
    setCurrentPage(page);
    setFilterConfig(prev => ({
      ...prev,
      page: page,
    }));
  };


  async function fetchFromBranch() {
    setShowLoader(true);
    setInventoryList([]);
    setTotalItems(0)

    const response = await searchAllItemList(filterConfig);
    if (response.data) {
      var data = response.data.data;
      data.map((data) => {
        var info = data;
        info.type = "";
        info.min = data.min ? numberFormat(data.min) : "";
        info.max = data.max ? numberFormat(data.max) : "";
        info.acceptable_variance = data.acceptable_variance
          ? numberFormat(data.acceptable_variance)
          : "";
        info.current_qty = numberFormat(data.current_qty);
        info.floating_qty = numberFormat(data.floating_qty);
        info.breakdown_current_qty = numberFormat(data.breakdown_current_qty);
        info.value_from = numberFormat(data.value_from);
        info.category_sub = data.subcategory_name ? 
          data.category_name + " - " + data.subcategory_name : 
          data.category_name 
        setInventoryList((prev) => [...prev, info]);
      });

      setTotalItems(response.data.size);
    }
    setShowLoader(false);
  }

  // SIDE BUTTONS
  function AdjustBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={`${row.id}|${row.type}`}
        onClick={handleSelectChange}
        value="adjust"
      >
        Adjust
      </button>
    );
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        id={`${row.id}|${row.branch_id}|${row.item_id}|${row.item_unit_id}|${row.unit_to_name}|${row.type}`}
        onChange={handleSelectChange}
      >
        <option value="" selected hidden>
          Select
        </option>
        <option value="history" className="color-options">
          History
        </option>
        <option value="adjust" className="color-options">
          Adjustment
        </option>
        {isAdmin && (
          <option value="delete" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    );
  }

  //FILTERS
  const handleFilters = (e) => {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleTabSelect = (tabKey) => {
    setFilterConfig((prev) => {
      return {
        ...prev,
        tab: tabKey,
        item_type: "",
        id: "",
        branch_name: "Select Branch",
      };
    });
    setInventoryList([]);
  };

  // HANDLERS
  const handleSelectChange = (e) => {
    const { value, id } = e.target;
    var itemSelected = id.split("|");
    var item_id = itemSelected[0];
    var branchID = itemSelected[1];
    var itemID = itemSelected[2];
    var itemUnitID = itemSelected[3];
    var itemUnit = itemSelected[4];
    var api = itemSelected[5];

    var endpoint = `${branchID}/${itemID}/${itemUnitID}/${itemUnit}`;
    if (value === "history") {
      navigate("/itemlists/history/" + endpoint);
    }
    if (value === "adjust") {
      navigate("/itemlists/branch-adjustment/" + item_id);
    }
  };

  async function fetchCategories() {
    const response = await getCategory({});
    if (response.data) {
      //categories
      var categories = response.data.data.map((category) => {
        var info = {}
        info.name = "category"
        info.value = category.name
        info.label = category.name
        info.id = category.id
        info.selected_value_name = "selected_category"
        return info
      })
      setCategories(categories);
    }
  }

  async function fetchBrands() {
    const response = await getBrand({});
    if (response.data) {
      var brands = response.data.data.map((brand) => {
        var info = {}
        info.name = "brand"
        info.value = brand.name
        info.label = brand.name
        info.id = brand.id
        info.selected_value_name = "selected_brand"
        return info
      })
      setBrand(brands);
    }
  }

  async function fetchBranches() {
    setBranches([]);

    const response = await searchBranch({});
    if (response.data) {
      var data = response.data.data.map((data) => {
        var branch = data;
        branch.label = data.name;
        branch.value = data.id;
        return branch
      });

      if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
        var filteredBranch = data.filter((data) => {
          return data.id === getBranchId()
        })
        setBranches(filteredBranch);
      } else {
        setBranches(data);
      }

    } else if (response.error) {
      setBranches([]);
    }

  }

  useEffect(() => {
    fetchCategories();
    fetchBrands();
    fetchBranches();
  }, []);

  useEffect(() => {
    if(filterConfig.branch_id !== "") {
      fetchFromBranch();
    }
  }, [filterConfig, currentPage]);
  
  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"STORE INVENTORY"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        
        <Row className="mb-4">
          <Col xs={12} lg={7}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> BRANCH INVENTORY </h1>
          </Col>
          <Col xs={12} lg={5} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
              <input
                  type="search"
                  name="name"
                className="search-bar"
                onKeyPress={(e) =>
                  e.key === ("Enter" || "NumpadEnter") && handleFilters(e)
                }
                placeholder="Search item name..."
              />
          </Col>
        </Row>
        
        <div className="tab-content">
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={6} lg={3} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Branch"
                styles={selectDropdownStyle}
                value={filterConfig.selected_branch}
                options={branches}
                onChange={(e) => { setFilterConfig((prev) => {
                    return { ...prev, 
                      "branch_id": e.value,
                      "selected_branch": {
                        value: e.value,
                        label: e.label 
                      }
                    };
                });}}
              />
            </Col>
            <Col xs={6} lg={3} className="mb-2 mb-lg-0">
              <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Brand"
                  styles={selectDropdownStyle}
                  value={filterConfig.selected_brand}
                  options={[{label: "All Brands", value: ""}, ...brand]}
                  onChange={(e) => { setFilterConfig((prev) => {
                    {console.log("brand e", e)}
                      return { ...prev, 
                        "brand": e.value,
                        "selected_brand": {
                          value: e.value,
                          label: e.label 
                        }
                      };
                  });}}
              />
            </Col>
            <Col xs={12} lg={3} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Category"
                styles={selectDropdownStyle}
                value={filterConfig.selected_category}
                options={[{label: "All Categories", value: ""}, ...categories]}
                onChange={(e) => { setFilterConfig((prev) => {
                    return { ...prev, 
                      "category": e.value,
                      "selected_category": {
                        value: e.value,
                        label: e.label 
                      }
                    };
                });}}
              />
            </Col>
            <Col xs={12} lg={3} className="mb-2 mb-lg-0">
              <Form.Select
                name="sales_type"
                value={filterConfig.sales_type}
                className="date-filter force-width w-full"
                onChange={(e) => handleFilters(e)}
              >
                <option value="" selected>
                  All Sales Type
                </option>
                <option value="retail">Retail</option>
                <option value="wholesale">Wholesale</option>
                <option value="universal">Both</option>
              </Form.Select>
            </Col>
          </Row>
          <div className="mb-2" />

          <TableWithDynamicPagination
            tableHeaders={[
              " ",
              "ITEM",
              "CATEGORY AND SUBCATEGORY",
              "FLOAT QTY",
              "CUR QTY",
              "INV UNIT",
              "BRKDN VALUE",
              "BRKDN UNIT",
              "MIN",
              "MAX",
              "ACCEPTABLE VARIANCE",
              "ACTIONS",
            ]}
            headerSelector={[
              "",
              "item_name",
              "category_sub",
              "floating_qty",
              "current_qty",
              "unit_from_name",
              "breakdown_current_qty",
              "unit_to_name",
              "min",
              "max",
              "acceptable_variance",
            ]}
            tableData={inventoryList}
            showLoader={showLoader}
            PendingBtn={(row) => AdjustBtn(row)}
            ActionBtn={(row) => ActionBtn(row)}
            // used in dynamic pagination
            totalItems={totalItems}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handlePageChange={handlePageChange}
          />
        </div>
        <div className="mb-2" />
      </div>
      <Footer/>
    </div>
  );
}
